import { render, staticRenderFns } from "./Player.vue?vue&type=template&id=c28c44c0&scoped=true&"
import script from "./Player.vue?vue&type=script&lang=js&"
export * from "./Player.vue?vue&type=script&lang=js&"
import style0 from "./Player.vue?vue&type=style&index=0&id=c28c44c0&prod&lang=scss&scoped=true&"
import style1 from "./Player.vue?vue&type=style&index=1&id=c28c44c0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c28c44c0",
  null
  
)

export default component.exports